import React from "react";

import { availabilityDotStyle } from "../bookingStyles";

const SELECTED_DATE_TOOLTIP = "Available on the selected date";

export function AvailabilityDot() {
  return (
    <span
      className="availability-dot"
      aria-hidden="true"
      title={SELECTED_DATE_TOOLTIP}
      style={availabilityDotStyle}
    />
  );
}
